"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcFileUploadDialog = void 0;
var react_1 = __importDefault(require("react"));
var Modal_1 = __importDefault(require("react-bootstrap/Modal"));
var AcModal_1 = require("../modal/AcModal");
var AcFileUpload_1 = require("./AcFileUpload");
var AcFileUploadDialog = function (_a) {
    var show = _a.show, handleCancel = _a.handleCancel, onFileUpload = _a.onFileUpload, maxFileSize = _a.maxFileSize, allowedExtensions = _a.allowedExtensions;
    return (react_1.default.createElement(AcModal_1.AcModal, { contentVariant: "transparent", contentClassName: "shadow-none", backdropClassName: "secondary-bg", size: "lg", show: show },
        react_1.default.createElement(Modal_1.default.Body, null,
            react_1.default.createElement(AcFileUpload_1.AcFileUpload, { handleCancel: handleCancel, onFileUpload: onFileUpload, maxFileSize: maxFileSize, allowedExtensions: allowedExtensions }))));
};
exports.AcFileUploadDialog = AcFileUploadDialog;
exports.AcFileUploadDialog.displayName = 'AcFileUploadDialog';
//# sourceMappingURL=AcFileUploadDialog.js.map